import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CreateNewSettlement from "../settlemet/CreateNewSettlement";
import "../../../styles/wtf-payouts/settlement-systems.css";
import SettlementsTables from "./SettlementsTables";
import { Row, Col } from "react-bootstrap";
import { setSelectedTab } from "../../../redux/reducers/tabsSlice";
import { resetSettlementFormValues } from "../../../redux/reducers/settlementFormSlice";
// import { ToastContainer } from "react-toastify";
import HelmetWrapper from "../../../HelmetWrapper";

function SettlementSystem() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedTab = useSelector((state) => state.tabs.selectedTab);

  const onClickClose = (e) => {
    e.preventDefault();
    navigate("/payouts");
    dispatch(setSelectedTab("settlement"));

    dispatch(resetSettlementFormValues());
  };

  return (
    <HelmetWrapper title="WTF: Settlement System">
      <div className="settlementSystemContainer pureComponent">
        {/* <ToastContainer /> */}

        <Row>
          <Col>
            <div className="closeButtonFromSettlementSystems">
              <button className="" onClick={onClickClose}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                </svg>
              </button>
            </div>
          </Col>
        </Row>

        {selectedTab !== "settlement-systems" && (
          <div className="innerSettlementSystemContainer">
            <CreateNewSettlement />
          </div>
        )}

        <SettlementsTables />
      </div>
    </HelmetWrapper>
  );
}

export default SettlementSystem;
